import { render, staticRenderFns } from "./person-info.vue?vue&type=template&id=5216b57a&scoped=true"
import script from "./person-info.vue?vue&type=script&lang=ts"
export * from "./person-info.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216b57a",
  null
  
)

export default component.exports